module.exports = __webpack_public_path__ + "img/dep_tobacco.db225914.png";